module.exports = __webpack_public_path__ + "img/attachmentSetting-1@2x.272210b.webp";